export default {
  brand: 'USFans Spreadsheet',
  nav_home: 'Accueil',
  nav_guide: 'Guide',
  nav_shopping_guide: 'Guide d\'achat',
  nav_categories: 'Catégories',
  nav_article: 'Articles',
  nav_faq: 'FAQ',
  nav_safety: 'Sécurité',

  hero_eyebrow: 'CENTRE DE RESSOURCES USFANS SPREADSHEET',
  hero_h1: 'USFans Spreadsheet — trouvez de meilleures listes, guides et ressources',
  hero_desc:
    'Explorez des ressources organisées de USFans spreadsheet, des guides d\'achat, des informations sur les vendeurs, des conseils de contrôle qualité, des détails de livraison, des avis et des comparaisons pratiques — le tout au même endroit.',
  hero_cta_main: 'USFans Spreadsheet',
  hero_cta_buy: 'Acheter maintenant',
  hero_cta_guide: 'Lire le guide',
  hero_trust: 'Ressource indépendante · Mise à jour régulièrement · Multilingue · Axée sur la sécurité',

  categories_title: 'Parcourir les catégories de produits',
  categories_subtitle: 'Accédez directement à la catégorie que vous cherchez sur le site principal.',
  categories_dropdown_label: 'Choisir une catégorie',
  categories_all: 'Toutes les catégories',

  about_eyebrow: 'QU\'EST-CE QUE USFANS SPREADSHEET ?',
  about_title: 'Tout ce qu\'il faut savoir sur USFans Spreadsheet',
  about_desc:
    'Au lieu de chercher parmi des informations éparpillées, explorez un centre de ressources structuré de USFans Spreadsheet couvrant des listes utiles, des guides d\'achat, la recherche de vendeurs, le contrôle qualité, la livraison, les informations d\'entrepôt, les avis, les coupons et les guides de sécurité.',
  about_cta: 'Explorer USFans Spreadsheet',

  resources_eyebrow: 'RESSOURCES POPULAIRES',
  resources_title: 'Ressources USFans populaires',
  resources_subtitle: 'Approfondissez avec nos guides et articles originaux et utiles.',
  article_card_title: 'USFans Spreadsheet : guide complet',
  article_card_desc:
    'Découvrez ce qu\'est une feuille de calcul USFans, comment l\'utiliser et comment acheter plus intelligemment avec des listes et ressources organisées.',
  read_more: 'Lire l\'article',
  read_guide: 'Lire le guide',

  pillars_eyebrow: 'GUIDES PILIERS USFANS',
  pillars_title: 'Guides USFans approfondis',
  pillars_subtitle:
    'Découvrez nos articles piliers originaux sur les avis, la livraison, les coupons, l\'entrepôt, la sécurité et plus encore.',

  safety_title: 'USFans est-il légitime et sûr ?',
  safety_desc:
    'Avant d\'utiliser une plateforme d\'achat en ligne, vérifiez l\'adresse du site, protégez les informations de votre compte, renseignez-vous sur les méthodes de paiement et méfiez-vous des offres suspectes. Nos ressources de sécurité expliquent des moyens pratiques de réduire les risques en ligne courants.',
  safety_cta: 'Visiter le centre de sécurité',

  faq_title: 'Questions fréquentes',
  faq_subtitle: 'Des réponses rapides aux questions les plus courantes sur USFans Spreadsheet.',
  faq_1_q: 'Qu\'est-ce que USFans Spreadsheet ?',
  faq_1_a:
    'USFans Spreadsheet est une ressource organisée qui rassemble des liens de produits, des catégories et des détails d\'achat au même endroit, pour parcourir et comparer les articles plus efficacement.',
  faq_2_q: 'Où trouver les liens USFans spreadsheet ?',
  faq_2_a:
    'Vous pouvez explorer les catégories de produits directement sur cette page ou continuer vers le site principal pour voir la sélection complète de liens et de produits.',
  faq_3_q: 'La feuille de calcul USFans est-elle mise à jour régulièrement ?',
  faq_3_a:
    'Oui, elle est actualisée régulièrement pour refléter les catégories et liens actuels. Confirmez toujours les dernières informations sur le site principal avant de commander.',

  final_title: 'Prêt à explorer les ressources USFans Spreadsheet ?',
  final_desc:
    'Commencez par le guide complet de USFans Spreadsheet, explorez des ressources pratiques et comparez les informations importantes avant de continuer vers le site principal.',
  final_cta_main: 'Explorer USFans Spreadsheet',
  final_cta_buy: 'Visiter le site principal',

  footer_tagline:
    'Un centre de ressources multilingue et indépendant pour USFans Spreadsheet — guides originaux, listes et informations de sécurité.',
  footer_explore: 'Explorer',
  footer_resources: 'Ressources',
  footer_languages: 'Langues',
  footer_disclaimer:
    'USFansSheet.casa est une ressource informative indépendante et n\'est pas officiellement affiliée ni approuvée par USFans, sauf indication explicite.',

  back_home: 'Retour à l\'accueil',
  related_article: 'Ressources associées',
  visit_main_site: 'Visiter le site principal',
  article_not_found: 'Article introuvable',

  category_shoes: 'Chaussures',
  category_hoodies: 'Hoodies/Pulls',
  category_tshirts: 'T-shirts',
  category_jackets: 'Vestes',
  category_pants: 'Pantalons/Shorts',
  category_headwear: 'Couvre-chefs',
  category_sets: 'Ensembles',
  category_underwear: 'Sous-vêtements/Slips',
  category_jersey: 'Maillot',
  category_accessories: 'Accessoires',
  category_bags: 'Sacs',
  category_belts: 'Ceintures',
  category_perfumes: 'Parfums',
  category_other: 'Autres articles',
};